// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
export const getLabelProps = (labelColor, labelVariant) => {
    const labelProps = {
        color: DlsColorTokens.text_Highest_Emphasis,
        variant: DlsFontVariants.body_B2_Med,
    };
    if (labelColor) {
        labelProps.color = labelColor;
    }
    if (labelVariant) {
        labelProps.variant = labelVariant;
    }
    return labelProps;
};
